// Selector simple de EPS/Aseguradoras - recibe las aseguradoras como prop
function SelectorEPS({ value, onChange, error, aseguradoras = [] }) {
  return (
    <div className="form-group">
      <label htmlFor="aseguradora">EPS / Aseguradora</label>
      <select 
        name="aseguradora" 
        className="form-control" 
        id="aseguradora" 
        value={value} 
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Seleccione...</option>
        {aseguradoras.map((item) => (
          <option key={'eps' + item.id} value={item.id}>
            {item.nombre}
          </option>
        ))}
      </select>
      {error && (
        <div className="invalid-feedback visible">
          {error}
        </div>
      )}
    </div>
  );
}

export default SelectorEPS;
